module.exports = __webpack_public_path__ + "media/src/images/icons/gray-fill-checkmark-circle-89bab49afebf50c7d86f14bf0afedfe1.svg";